import { Button, InputTextarea } from '@design-systems/canvas-ui'
import Icon, { ArrowUpIcon } from '@design-systems/react-icons'

const ChatComposer = ({
  draft,
  isSending,
  onDraftChange,
  onSubmit,
  sessionBrand,
  textareaRef,
}) => {
  const isBrandScoped = Boolean(sessionBrand)

  return (
    <div className="assistant__composer-wrap">
      <p className="assistant__fixed-scope">
        {isBrandScoped ? (
          <>
            Focused on <strong>{sessionBrand}</strong>
          </>
        ) : (
          <>
            Focused on <strong>All Target Brands</strong>
          </>
        )}
      </p>
      <form className="assistant__composer" onSubmit={onSubmit}>
        <div className="assistant__composer-editor">
          <InputTextarea
            aria-label="Ask Brand DNA a question"
            canGrow
            className="assistant__composer-input"
            onChange={(event) => onDraftChange(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                onSubmit(event)
              }
            }}
            placeholder="Ask about this brand, its content, or an asset..."
            ref={textareaRef}
            rows={2}
            value={draft}
          />
          <Button
            aria-label="Send message"
            className="assistant__composer-send"
            isDisabled={!draft.trim() || isSending}
            isLoading={isSending}
            type="submit"
            variant="primary"
          >
            <Icon aria-hidden="true" svg={ArrowUpIcon} />
          </Button>
        </div>
      </form>
      <p className="assistant__disclaimer">
        Brand DNA can make mistakes. Check important details against the source
        guidance.
      </p>
    </div>
  )
}

export default ChatComposer
